/*!
 * wasm-health.js — extracted 2026-07-08 from resources/views/layouts/app.blade.php
 * (inline config script, second half: __hasRealFFmpeg discriminator, __warmUpFFmpeg,
 * the broken-WASM advisory banner, lite-path success marker, FFmpegProcessor.init
 * health gate, cascade fail-fast watcher — plus the window.__CDN router that used
 * to be defined just below the tool-slug block; nothing in between referenced it).
 *
 * Loaded SYNCHRONOUSLY (no defer) at the exact old inline position, so
 * document-order execution is unchanged.
 *
 * Expects these inline-shim globals (set by the layout BEFORE this tag):
 *   window.__LOCALE — page locale string ('ru', 'en', ...)
 *   window.__IS_RU  — (__LOCALE === 'ru'); drives banner language and the
 *                     vps-first vs cdn-first __CDN routing. The old Blade
 *                     currentLocale==='ru' branches became __IS_RU ternaries —
 *                     intl locales received the EN branch before and still do.
 * Reads at CALL time only (may be defined later in document order):
 *   __TOOL_SLUG, __TOOL_LITE_CAPABLE, __wasmHealthy, __wasmHealthReset,
 *   __ae, __aeCritical, FFmpegProcessor, __toast.
 */
    // Discriminator for "is the REAL ffmpeg-processor.js loaded?" — distinct from
    // the __sharedModule queue-stub that timbrica-core installs on every page so
    // tools can defer-call FFmpegProcessor.X before the script lands. Defined
    // early because installInitGate / __decodeAudio / __ensureFFmpeg / denoise.blade
    // all need it before their own setInterval/click handlers fire.
    window.__hasRealFFmpeg=function(){
        return !!(window.FFmpegProcessor && !window.FFmpegProcessor.__isStub);
    };
    // Proactive FFmpeg WASM warm-up. Kicks off FFmpegProcessor.init() ~3 s
    // after page load — bytes download in background, WASM compiles while
    // the user is reading the page / picking a file. By click time the
    // engine is ready, so the dreaded "Instantiate timeout" cascade
    // (Aliya's 11-source 60 s × 11 = 11 min) shifts to background work
    // the user doesn't sit through.
    //
    // No prefetch <link>: those force the bytes onto the wire even when
    // the user navigates away in <3 s. The init() path uses our SW cache
    // and the @ffmpeg fallback chain — same bytes, same caching, just
    // overlapped with idle time instead of click-to-result latency.
    //
    // Skip when: FFmpegProcessor not loaded yet, already initialised,
    // already in-flight, or user is on a page that never needs WASM (no
    // tool slug). Doesn't conflict with the lite path: lite tools that
    // don't need WASM simply ignore the warmed-up engine.
    window.__warmUpFFmpeg=(function(){
        var started=false;
        return function(){
            if(started)return;
            if(typeof FFmpegProcessor==='undefined')return;
            if(FFmpegProcessor.isReady&&FFmpegProcessor.isReady())return;
            started=true;
            // Mark this as a SPECULATIVE warm. The broken-WASM banner means
            // "your browser can't run the processor" — but that is FALSE for a
            // lite-capable tool (e.g. /join with mp3/wav uses Web Audio +
            // lamejs, never FFmpeg). On iOS WebKit the FFmpeg warm always
            // times out, which used to flash the scary red banner at file-pick
            // even though the user's job needs no FFmpeg (To_li_man 2026-06-13:
            // "can't start the handler" on /join mp3). The banner gates
            // on this flag + __TOOL_LITE_CAPABLE to stay quiet during a
            // speculative warm; a REAL FFmpeg op that later fails (warming=false)
            // still surfaces it.
            window.__ffmpegWarming=true;
            function __warmDone(){ window.__ffmpegWarming=false; }
            // Pre-flight: WASM health probe (timbrica-core.js). Lazy —
            // runs in parallel with this warm-up call (first user gesture).
            // Resolves ~instantly on healthy browsers, ~3 s on broken ones
            // (Yandex Browser 26.x sometimes hangs in WebAssembly.instantiate).
            // If broken, surface the banner immediately and skip the 12-minute
            // cascade entirely. Doc case: andre.d.titov 2026-04-29 — 9.7 MB
            // MP4 on /ru/video-crop, 11 min cascade then bug-report.
            (typeof window.__wasmHealthy==='function'?window.__wasmHealthy():Promise.resolve(true)).then(function(healthy){
                if(!healthy){
                    try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'warmup_skipped_broken',tool:(window.__TOOL_SLUG||'unknown')})}catch(_){}
                    window.__wasmBrokenBanner&&window.__wasmBrokenBanner();
                    __warmDone();
                    return;
                }
                try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'warmup_start',tool:(window.__TOOL_SLUG||'unknown')})}catch(_){}
                var t0=Date.now();
                /* На слабой памяти греем БАЙТЫ, а не движок — тот же рубеж, что у
                   EngineWarmer.warm(). Прогрев спекулятивный: человек, может, и не
                   дойдёт до обработки, а инстанс FFmpeg стоит ~104 МБ (замер
                   03.09.2026) и висит всё время, пока он выбирает второй файл. На
                   4-ГБ телефоне это и есть убитая вкладка (жалоба 01.09.2026,
                   Redmi Note 9 Pro: «постоянно перезагружает страницу»). Байты —
                   ровно то, ради чего прогрев и заводился (скачать 30 МБ заранее);
                   инстанс поднимет первый же exec-вход за 204 мс.
                   ⚠️ Это ТРЕТИЙ путь прогрева (warm-engines у зоны загрузки,
                   ensureWarm у тула и этот). Правило должно быть одно на все три,
                   иначе тул, обошедший два, всё равно получит инстанс. */
                var _lowMem=(function(){try{var B=window.__memBudget;return !!(B&&typeof B.gb==='function'&&B.gb()<=4)}catch(_){return false}})();
                if(_lowMem&&typeof FFmpegProcessor.prefetch==='function'){
                    FFmpegProcessor.prefetch().then(function(ok){
                        if(ok)try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'warmup_bytes_ok',tool:(window.__TOOL_SLUG||'unknown'),ms:Date.now()-t0})}catch(_){}
                    }).catch(function(){}).finally(__warmDone);
                    return;
                }
                FFmpegProcessor.init().then(function(ok){
                    if(ok)try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'warmup_ok',tool:(window.__TOOL_SLUG||'unknown'),ms:Date.now()-t0})}catch(_){}
                }).catch(function(e){
                    try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'warmup_failed',tool:(window.__TOOL_SLUG||'unknown'),err:((e&&e.message)||'').substring(0,100),ms:Date.now()-t0})}catch(_){}
                    window.__wasmBrokenBanner&&window.__wasmBrokenBanner();
                }).finally(__warmDone);
            });
        };
    })();
    /* WASM-broken banner — shown when warm-up failed AND no successful
       lite-path completion has happened. Idempotent (one-shot). */
    window.__wasmBrokenBanner=(function(){
        var shown=false;
        return function(){
            if(shown)return;
            // Speculative-warm suppression: a lite-capable tool (mp3/wav join,
            // etc.) does NOT need FFmpeg for its primary path, so a failed
            // SPECULATIVE warm-up must not flash the alarmist banner. Only a
            // genuine FFmpeg op that fails (warming=false) shows it. Fixes the
            // /join iOS "can't start the handler" false alarm.
            if(window.__ffmpegWarming&&window.__TOOL_LITE_CAPABLE){
                try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'broken_banner_suppressed_lite',tool:(window.__TOOL_SLUG||'unknown')})}catch(_){}
                return;
            }
            // Defer so a successful lite-path tool_complete that lands in
            // the next 1.5 s suppresses the banner — pitch / volume / etc.
            // can succeed on browsers where ffmpeg-core.wasm fails, and we
            // shouldn't scare those users.
            setTimeout(function(){
                if(shown)return;
                if(window.__litePathSucceeded)return;
                shown=true;
                var bg='var(--danger,#ef4444)',fg='#fff';
                var box=document.createElement('div');
                box.id='__wasm-broken-banner';
                box.setAttribute('role','alert');
                box.style.cssText='position:fixed;top:0;left:0;right:0;z-index:99999;padding:14px 18px;background:'+bg+';color:'+fg+';font-size:14px;line-height:1.4;text-align:center;box-shadow:0 4px 16px rgba(0,0,0,.25);font-family:inherit';
                // Error language follows the PAGE locale only — never the visitor's
                // browser language. The navigator.language fallback used to surface
                // Russian diagnostics to a Russian-configured browser even on the
                // intl domain (where ru isn't served); window.__LOCALE is always set
                // and is the source of truth. RU domain still gets ru.
                var ru=(window.__LOCALE||'')==='ru';
                /* Browser + OS detection. UA-string is the only reliable signal
                   client-side (Sec-CH-UA needs server). We use this to:
                     1. surface the detected env so the user sees we recognise
                        their setup (not a generic "something broke");
                     2. CONDITIONALLY render advisory — never tell a Chrome
                        user to "open in Chrome", never show Edge-specific
                        SmartScreen advice on Firefox, etc.
                   UA chains: order matters. YaBrowser/OPR/Edg appear ALONGSIDE
                   Chrome in the UA, so check those first to avoid mis-classifying
                   Yandex/Opera/Edge as "real Chrome". */
                var ua=navigator.userAgent||'';
                var isYandex   = /YaBrowser\/(\d+)/.test(ua);
                var yaVer      = isYandex ? RegExp.$1 : '';
                var isOpera    = /OPR\/(\d+)/.test(ua);
                var operaVer   = isOpera ? RegExp.$1 : '';
                var isEdge     = /Edg\/(\d+)/.test(ua);
                var edgeVer    = isEdge ? RegExp.$1 : '';
                var isFirefox  = /Firefox\/(\d+)/.test(ua);
                var firefoxVer = isFirefox ? RegExp.$1 : '';
                /* "Real" Chrome — Chromium UA token present AND no derivative
                   marker (Yandex/Opera/Edge/Brave/Vivaldi/etc). Brave hides
                   itself in UA, so pure Chrome detection here can include Brave.
                   That's fine — Brave behaves like Chrome for our purposes. */
                var isChrome   = /Chrome\/(\d+)/.test(ua) && !isYandex && !isOpera && !isEdge;
                var chromeVer  = isChrome ? RegExp.$1 : '';
                /* Safari only on Apple platforms; "Safari" string appears in
                   Chrome UA too, hence the not-Chrome guard. */
                var isSafari   = /Safari\//.test(ua) && !/Chrome\/|CriOS|FxiOS|EdgiOS/.test(ua);
                var safariVer  = isSafari ? (/Version\/(\d+)/.test(ua) ? RegExp.$1 : '') : '';
                var isWindows  = /Windows/.test(ua);
                var isMac      = /Mac OS X/.test(ua) && !/Mobile/.test(ua);
                var isLinux    = /Linux/.test(ua) && !/Android/.test(ua);
                var isAndroid  = /Android/.test(ua);
                var isIos      = /iPhone|iPad|iPod/.test(ua) || (isSafari && /Mac/.test(ua) && navigator.maxTouchPoints>1);
                var isMobile   = isAndroid || isIos;
                var detected   =
                    isYandex  ? 'Yandex Browser '+yaVer
                  : isOpera   ? 'Opera '+operaVer
                  : isEdge    ? 'Edge '+edgeVer
                  : isFirefox ? 'Firefox '+firefoxVer
                  : isChrome  ? 'Chrome '+chromeVer
                  : isSafari  ? 'Safari '+safariVer
                  :             'your browser';
                /* Per-browser cause line — avoid generic "switching browsers
                   usually fixes it" when the user is already in the most stable
                   browser (Chrome). Cause text reflects what's actually likely
                   to break WebAssembly in THIS environment. */
                function buildCause(lang){
                    if (isYandex) return (window.__IS_RU?('Возможные причины: антивирус (Kaspersky / Dr.Web), расширение или встроенный «Защитник» Yandex Browser блокирует WebAssembly. Это происходит у каждого 40-го пользователя Yandex Browser.'):('Likely cause: antivirus (Kaspersky / Dr.Web), browser extension, or the built-in Protect feature in Yandex Browser is blocking WebAssembly. This affects ~1 in 40 Yandex Browser users.'));
                    if (isOpera) return (window.__IS_RU?('Возможные причины: встроенный блокировщик Opera, VPN-расширение или антивирус блокирует WebAssembly. Часто помогает временное отключение Opera Shield.'):('Likely cause: built-in Opera ad-blocker, VPN extension or antivirus is blocking WebAssembly. Disabling Opera Shield temporarily usually helps.'));
                    if (isEdge && isWindows) return (window.__IS_RU?('Возможные причины: SmartScreen / Defender Application Guard, корпоративная групповая политика или антивирус блокирует WebAssembly. На рабочих ноутбуках это самая частая причина.'):('Likely cause: SmartScreen / Defender Application Guard, corporate group policy or antivirus is blocking WebAssembly. Most common on managed work laptops.'));
                    if (isFirefox) return (window.__IS_RU?('Возможные причины: Enhanced Tracking Protection в строгом режиме, расширение (uBlock Origin / NoScript) или антивирус блокирует WebAssembly. Реже — отключенный javascript.options.wasm в about:config.'):('Likely cause: Enhanced Tracking Protection on Strict, an extension (uBlock Origin / NoScript) or antivirus is blocking WebAssembly. Rarely — javascript.options.wasm disabled in about:config.'));
                    if (isChrome && isWindows) return (window.__IS_RU?('В Chrome это редкий случай. Почти всегда виноват антивирус (Kaspersky / Dr.Web / Avast / Norton) с включённым HTTPS-сканированием — он подменяет ответы и WebAssembly не запускается. Реже — расширение или групповая политика организации.'):('Rare in Chrome — almost always caused by an antivirus (Kaspersky / Dr.Web / Avast / Norton) with HTTPS scanning enabled, which rewrites responses and breaks WebAssembly. Occasionally an extension or organisation group policy.'));
                    if (isChrome && isMac) return (window.__IS_RU?('В Chrome на macOS это редкий случай. Скорее всего расширение блокирует WebAssembly, реже — корпоративный профиль управления (MDM).'):('Rare in Chrome on macOS. Most likely an extension is blocking WebAssembly; occasionally a corporate management profile (MDM).'));
                    if (isChrome && isLinux) return (window.__IS_RU?('В Chrome на Linux это редкий случай. Проверьте расширения и политики Snap / Flatpak (если Chrome установлен через них).'):('Rare in Chrome on Linux. Check extensions and Snap / Flatpak policies if Chrome was installed that way.'));
                    if (isSafari && isIos) return (window.__IS_RU?('В Safari на iOS WebAssembly иногда отключается режимом «Lockdown Mode» (Настройки → Конфиденциальность → Режим блокировки) или включёнными «Content Blockers».'):('In Safari on iOS, WebAssembly is occasionally disabled by Lockdown Mode (Settings → Privacy → Lockdown Mode) or active Content Blockers.'));
                    if (isSafari) return (window.__IS_RU?('Возможные причины: Content Blocker, расширение конфиденциальности или Lockdown Mode блокирует WebAssembly.'):('Likely cause: a Content Blocker, privacy extension or Lockdown Mode is blocking WebAssembly.'));
                    if (isMobile) return (window.__IS_RU?('Возможные причины: режим экономии данных, режим экономии заряда или встроенный блокировщик мобильного браузера блокирует WebAssembly.'):('Likely cause: data-saver mode, battery-saver mode or the built-in mobile-browser blocker is blocking WebAssembly.'));
                    return (window.__IS_RU?('Возможные причины: антивирус блокирует WebAssembly, расширение, или групповая политика.'):('Likely cause: antivirus blocking WebAssembly, an extension, or group policy.'));
                }
                /* Per-environment advisory — concrete steps the user can take
                   in THIS browser/OS. The order is incognito first (universal
                   one-click test that disables most extensions), then env-
                   specific fixes, then a last-resort browser switch — which
                   omits the browser the user is already in. */
                function buildAdvisory(lang){
                    var steps=[];
                    /* The host the reader is ON, never a hardcoded domain: on
                       tembrica.com this used to tell people to whitelist the
                       one-letter twin timbrica.com. And advice stays PER SITE —
                       "turn off HTTPS scanning / site-safety checks" switches
                       off protection for the whole machine and reads exactly
                       like the social engineering antivirus heuristics hunt
                       (security audit 2026-10-01, Avast blocks tembrica.com). */
                    var host=String(location.hostname||'').replace(/^www\./,'')||'this site';
                    /* Universal incognito hint — works on Chrome/Firefox/Edge/
                       Opera/Yandex; effectively disables third-party extensions
                       and clears state. Skip on Safari iOS (Private Browsing
                       behaves differently and rarely fixes WASM issues). */
                    if (!isSafari && !isMobile) {
                        var incog =
                            isFirefox ? ((window.__IS_RU?('приватном окне (Ctrl+Shift+P)'):('a Private Window (Ctrl+Shift+P)')))
                          : isMac     ? ((window.__IS_RU?('режиме инкогнито (⌘+Shift+N)'):('Incognito mode (⌘+Shift+N)')))
                          :             ((window.__IS_RU?('режиме инкогнито (Ctrl+Shift+N)'):('Incognito mode (Ctrl+Shift+N)')));
                        steps.push((window.__IS_RU?('Откройте эту страницу в '+incog+'. Это отключит расширения и покажет, виноваты ли они.'):('Open this page in '+incog+'. That disables extensions and shows whether they are the cause.')));
                    }
                    /* Browser-specific built-in feature toggles. */
                    if (isYandex) {
                        steps.push((window.__IS_RU?('Если страницу блокирует «Защита» Yandex Browser — нажмите на значок замка или щита в адресной строке и разрешите работу для '+host+' (только для этого сайта).'):('If Yandex Browser Protect blocks this page, click the lock or shield icon in the address bar and allow '+host+' (for this site only).')));
                    }
                    if (isOpera) {
                        steps.push((window.__IS_RU?('Кликните по щиту Opera в адресной строке → отключите блокировщик и трекер-блокировку для '+host+'.'):('Click the Opera shield in the address bar → disable the ad-blocker and tracker-blocker for '+host+'.')));
                    }
                    if (isFirefox) {
                        steps.push((window.__IS_RU?('Кликните по щиту слева от адреса '+host+' → «Отключить защиту от отслеживания для этого сайта».'):('Click the shield to the left of the '+host+' address → "Turn off Enhanced Tracking Protection for this site".')));
                    }
                    if (isEdge) {
                        steps.push((window.__IS_RU?('Меню (⋯) → Настройки → Конфиденциальность → добавьте '+host+' в исключения «Защиты от отслеживания».'):('Menu (⋯) → Settings → Privacy → add '+host+' to the "Tracking prevention" exceptions.')));
                    }
                    /* Antivirus advice — only on platforms where it actually
                       matters. AV intercepting HTTPS is overwhelmingly a
                       Windows phenomenon; on macOS / Linux / mobile this is
                       irrelevant noise. */
                    if (isWindows) {
                        steps.push((window.__IS_RU?('Если установлен Kaspersky: Настройки → Сетевые параметры → «Исключения» для проверки защищённых соединений → добавьте '+host+'.'):('If you have Kaspersky: Settings → Network settings → exclusions for secure-connection scanning → add '+host+'.')));
                        steps.push((window.__IS_RU?('Если установлен Dr.Web / Avast / Norton — добавьте '+host+' в исключения веб-защиты (только этот сайт, защиту целиком не отключайте).'):('If you have Dr.Web / Avast / Norton — add '+host+' to the web-shield exceptions (this site only; keep the protection itself on).')));
                    }
                    if (isSafari && isIos) {
                        steps.push((window.__IS_RU?('Настройки → Конфиденциальность и безопасность → Режим блокировки — выключите его для Safari, если включали.'):('Settings → Privacy & Security → Lockdown Mode — turn it off for Safari if you have it on.')));
                    }
                    if (isMobile) {
                        steps.push((window.__IS_RU?('Отключите режим экономии данных и режим энергосбережения — оба могут блокировать WebAssembly на Android/iOS.'):('Disable data-saver and battery-saver modes — both can block WebAssembly on Android/iOS.')));
                    }
                    /* Last-resort: open in another browser. Conditionally list
                       only browsers the user is NOT in. Don't recommend Chrome
                       to a Chrome user. */
                    var alts = [];
                    if (!isChrome  && !isMobile) alts.push('Chrome');
                    if (!isFirefox && !isMobile) alts.push('Firefox');
                    if (alts.length === 1) {
                        steps.push((window.__IS_RU?('Если ничего не помогло — откройте страницу в '+alts[0]+'. Это самый быстрый способ убедиться, что проблема в текущем браузере.'):('If nothing helped — open this page in '+alts[0]+'. That is the quickest way to confirm the issue is in the current browser.')));
                    } else if (alts.length === 2) {
                        steps.push((window.__IS_RU?('Если ничего не помогло — откройте страницу в Chrome или Firefox. Это самый надёжный способ обойти проблему.'):('If nothing helped — open this page in Chrome or Firefox. That is the most reliable workaround.')));
                    } else if (isMobile) {
                        steps.push((window.__IS_RU?('Если ничего не помогло — откройте страницу на компьютере (мобильные браузеры чаще ограничивают WebAssembly).'):('If nothing helped — open this page on a desktop computer (mobile browsers more often restrict WebAssembly).')));
                    }
                    return steps;
                }
                var advisorySteps = buildAdvisory(ru?'ru':'en');
                /* Header CTA buttons — only show alternative-browser links the
                   user is NOT already in. Pure Chrome users see only Firefox;
                   Firefox users see only Chrome; Yandex/Opera/Edge users see
                   both. The button isn't useless when the user is in that
                   browser — it's actively misleading ("open in Chrome" while
                   you ARE in Chrome reads as a system bug). */
                /* #1121 (2026-07-22, 304 users/7d): a CPU without WebAssembly
                   SIMD is TERMINAL for the wasm engine — switching browsers or
                   "trying anyway" cannot help (the instruction set is missing
                   in hardware). Sergey's session: 15 upload-retry loops fed by
                   the generic banner's "Try anyway" + misleading network hints.
                   For this class: honest text, no browser CTAs, no anyway. */
                var simdDead = false;
                try { simdDead = typeof window.__hasWasmSIMD === 'function' && !window.__hasWasmSIMD() && !window.__nosimdMode; } catch(_) {}
                if (simdDead) { try { window.__wasmDead = 'simd'; } catch(_) {} }
                var showChromeBtn  = !isChrome  && !isMobile && !simdDead;
                var showFirefoxBtn = !isFirefox && !isMobile && !simdDead;
                var L=
                    (window.__IS_RU?(
                       {msg:'Не удаётся запустить движок обработки в '+detected+'.',
                       cause:buildCause('ru'),
                       chrome:'Открыть в Chrome',firefox:'Открыть в Firefox',anyway:'Всё равно попробовать',
                       close:'Закрыть',diag:'Прислать диагностику',
                       advisorySummary:'▾ Что попробовать прямо сейчас',
                       advisoryTitle:'Шаги без смены браузера:'}
                    ):(
                       {msg:'Cannot start our processing engine in '+detected+'.',
                       cause:buildCause('en'),
                       chrome:'Open Chrome',firefox:'Open Firefox',anyway:'Try anyway',
                       close:'Close',diag:'Send diagnostic',
                       advisorySummary:'▾ Things to try right now',
                       advisoryTitle:'Steps without switching browsers:'}
                    ));
                /* Track which CTA the user picks. The click telemetry is the only
                   way to validate banner UX — we already know it appears; we
                   need to know what users do next (close / switch / override). */
                var trackBanner=function(action){
                    try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'broken_banner_click',action:action,tool:(window.__TOOL_SLUG||'unknown')})}catch(_){}
                };
                /* Direct download links — chrome.com / mozilla.org. Not deep-link
                   "intent://" because Chromium's intent URLs only work from inside
                   Chrome, defeating the purpose. Plain https links are universal. */
                var btnStyle='background:rgba(255,255,255,.95);color:#b91c1c;border:none;border-radius:6px;padding:6px 14px;cursor:pointer;font-size:13px;font-weight:600;text-decoration:none;display:inline-block;font-family:inherit';
                var ghostStyle='background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.4);border-radius:6px;padding:6px 14px;cursor:pointer;font-size:13px;font-family:inherit';
                if (simdDead) {
                    L.msg = window.__IS_RU
                        ? 'Процессор этого устройства не поддерживает современный WebAssembly (SIMD).'
                        : "This device's CPU does not support modern WebAssembly (SIMD).";
                    L.cause = window.__IS_RU
                        ? 'Обычно это аппаратура до 2008 года. Инструменты обработки не заработают на этом устройстве ни в одном браузере — попробуйте более новый компьютер или телефон. Повторная загрузка файла не поможет.'
                        : 'This usually means pre-2008 hardware. The processing tools will not run on this device in any browser — try a newer computer or phone. Re-uploading the file will not help.';
                }
                var chromeBtnHtml  = showChromeBtn  ? '<a href="https://www.google.com/chrome/" target="_blank" rel="noopener" data-banner-action="chrome" style="'+btnStyle+'">'+L.chrome+'</a>' : '';
                var firefoxBtnHtml = showFirefoxBtn ? '<a href="https://www.mozilla.org/firefox/new/" target="_blank" rel="noopener" data-banner-action="firefox" style="'+btnStyle+'">'+L.firefox+'</a>' : '';
                box.innerHTML=
                    '<div style="max-width:1000px;margin:0 auto;display:flex;flex-direction:column;gap:8px">'+
                    '<div style="display:flex;align-items:center;gap:10px;justify-content:center;flex-wrap:wrap">'+
                    '<span style="font-size:18px">⚠️</span>'+
                    '<span style="flex:1;min-width:200px;text-align:start"><strong>'+L.msg+'</strong></span>'+
                    chromeBtnHtml+
                    firefoxBtnHtml+
                    (simdDead ? '' : '<button type="button" data-banner-action="anyway" style="'+ghostStyle+'">'+L.anyway+'</button>')+
                    '<button type="button" data-banner-action="close" aria-label="'+L.close+'" style="'+ghostStyle+';width:30px;padding:6px;font-size:16px">×</button>'+
                    '</div>'+
                    '<div style="font-size:12px;opacity:.92;text-align:center;line-height:1.5">'+L.cause+
                    ' <button type="button" data-banner-action="diag" style="background:transparent;color:#fff;border:none;text-decoration:underline;cursor:pointer;font-size:12px;font-family:inherit;padding:0">'+L.diag+'</button>'+
                    '</div>'+
                    /* Targeted advisory — collapsible <details> so the banner
                       stays compact, but users who want concrete steps can
                       expand and follow them. Native HTML, no extra JS. */
                    '<details style="font-size:12px;opacity:.92;line-height:1.6;margin-top:4px" data-banner-action="advisory-details">'+
                    '<summary style="cursor:pointer;text-align:center;list-style:none;outline:none">'+L.advisorySummary+'</summary>'+
                    '<div style="max-width:780px;margin:8px auto 0;padding:10px 14px;background:rgba(0,0,0,.18);border-radius:8px;text-align:start">'+
                    '<div style="font-weight:600;margin-bottom:6px">'+L.advisoryTitle+'</div>'+
                    '<ol style="margin:0;padding-inline-start:20px">'+
                    advisorySteps.map(function(s){return '<li style="margin-bottom:4px">'+s+'</li>'}).join('')+
                    '</ol>'+
                    '</div>'+
                    '</details>'+
                    '</div>';
                /* Track <details> expansion separately so we know how often
                   users actually open the targeted-advisory section. */
                var detailsEl=box.querySelector('details[data-banner-action="advisory-details"]');
                if(detailsEl){
                    detailsEl.addEventListener('toggle',function(){
                        if(detailsEl.open)trackBanner('advisory-opened');
                    });
                }
                box.addEventListener('click',function(e){
                    var t=e.target;
                    while(t && t!==box && !t.dataset.bannerAction)t=t.parentNode;
                    if(!t || !t.dataset)return;
                    var action=t.dataset.bannerAction;
                    if(!action || action==='advisory-details')return; /* handled by toggle event */
                    trackBanner(action);
                    if(action==='anyway'){
                        /* User explicitly overrides — clear the broken flag and
                           remove banner. Probe verdict can be a false positive
                           on niche browsers; this lets the user proceed. They'll
                           hit the cascade if their browser really is broken,
                           but at least it's their choice.
                           __wasmHealthReset() nulls the module-level cached probe
                           promise — the OLD handler only wrote sessionStorage='1',
                           but __wasmHealthy() returns the cached promise BEFORE it
                           reads sessionStorage, so the override was silently dead
                           and the user stayed bricked (bug 2026-06-17). */
                        if(typeof window.__wasmHealthReset==='function')window.__wasmHealthReset(true);
                        else try{sessionStorage.setItem('__wasm_health','1')}catch(_){}
                        window.__wasmInitAborted=false; // re-enable cascade
                        box.remove();
                    } else if(action==='close'){
                        box.remove();
                    } else if(action==='diag'){
                        /* Diagnostic upload: collect everything that COULD be
                           the root cause client-side and ship to /api/log-error.
                           Aggregating these across many users is the only way
                           we'll learn which AV / extension / policy combos
                           actually break WebAssembly engines.
                           Then we can ship targeted fixes (e.g. specific AV
                           vendor advisory, browser-version blocklist update). */
                        try {
                            var c=navigator.connection||navigator.mozConnection||{};
                            var diag={
                                ua:ua.substring(0,400),
                                tool:window.__TOOL_SLUG||'unknown',
                                detected:detected,
                                /* Browser/OS one-letter flags so aggregating
                                   across diag uploads is grep-able: e.g.
                                   br='C' on Windows isolates "Chrome on
                                   Windows" — the cluster we expect to be
                                   dominated by AV. */
                                br:isYandex?'Y':isOpera?'OP':isEdge?'E':isFirefox?'F':isChrome?'C':isSafari?'S':'?',
                                os:isWindows?'W':isMac?'M':isLinux?'L':isAndroid?'A':isIos?'I':'?',
                                mob:isMobile?1:0,
                                lang:navigator.language,
                                lastFailedSrc:(window.__lastFailedSrc||null),
                                wasm:typeof WebAssembly!=='undefined',
                                wasmValidate:(typeof WebAssembly!=='undefined'&&typeof WebAssembly.validate==='function'),
                                sab:typeof SharedArrayBuffer!=='undefined',
                                co:window.crossOriginIsolated||false,
                                dm:navigator.deviceMemory||0,
                                hc:navigator.hardwareConcurrency||0,
                                ct:c.effectiveType||'',
                                dl:c.downlink||0,
                                sd:c.saveData||false,
                                tz:Intl.DateTimeFormat().resolvedOptions().timeZone,
                                ts:new Date().toISOString(),
                                /* Hint signals that often correlate with broken WASM:
                                   - Specific Yandex Browser version
                                   - Specific Chrome version
                                   - Plugins / extensions visible (most are hidden post-Chrome 91, but some leak) */
                                pl:Array.from(navigator.plugins||[]).map(function(p){return p.name}).slice(0,5),
                                /* Did the lazy probe even ran? sessionStorage tells us */
                                probe:(function(){try{return sessionStorage.getItem('__wasm_health')}catch(_){return null}})()
                            };
                            navigator.sendBeacon('/api/log-error',JSON.stringify([{type:'wasm-broken-diag',src:JSON.stringify(diag).substring(0,1500),page:location.pathname,ua:ua.substring(0,200)}]));
                            var thanks=(window.__IS_RU?('✓ Спасибо, диагностика отправлена. Мы свяжемся, если найдём паттерн.'):('✓ Thanks, diagnostic sent. We will follow up if we spot a pattern.'));
                            box.innerHTML='<div style="max-width:1000px;margin:0 auto;text-align:center;padding:4px">'+thanks+'</div>';
                            setTimeout(function(){box.remove()},4000);
                        } catch(_) {}
                    }
                    /* chrome / firefox: let the <a> tag's default href navigate. */
                });
                document.body.appendChild(box);
                try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'broken_banner_shown',tool:(window.__TOOL_SLUG||'unknown'),simd_terminal:simdDead?1:0})}catch(_){}
            },1500);
        };
    })();
    /* Mark window.__litePathSucceeded when ANY tool completes via lite —
       suppresses the broken-WASM banner for that session. */
    window.addEventListener('file-downloaded',function(){
        // Heuristic: file-downloaded usually means at least one path
        // worked end-to-end (lite or otherwise). Don't show the alarmist
        // banner if user already got a file out.
        window.__litePathSucceeded=true;
    });
    /* Direct-init short-circuit: when a tool calls FFmpegProcessor.init()
       without going through warm-up (e.g. user clicks Process before any
       interaction trigger fires, or ad-gate workflow), the unhealthy-WASM
       probe still has to gate the cascade. Wrap the method on first
       availability — once before any caller, idempotent. Resolves to
       `false` (init failure) when probe is broken, mirroring init()
       contract. Banner is shown so the user sees actionable advice. */
    (function installInitGate(){
        // Wait for the REAL FFmpegProcessor — wrapping the __sharedModule stub is
        // pointless because the real script reassigns `window.FFmpegProcessor =
        // realImpl`, which discards our wrapped init. Use __hasRealFFmpeg (false
        // for stub, true for real) and extend the timeout slightly to cover
        // tool pages where the script is `defer`'d on slow connections (~10 s).
        var attempts=0;
        var iv=setInterval(function(){
            attempts++;
            if(!window.__hasRealFFmpeg||!window.__hasRealFFmpeg()){
                if(attempts>100)clearInterval(iv); // 10 s max
                return;
            }
            clearInterval(iv);
            if(FFmpegProcessor.__healthGated)return;
            FFmpegProcessor.__healthGated=true;
            var origInit=FFmpegProcessor.init.bind(FFmpegProcessor);
            FFmpegProcessor.init=function(){
                var args=arguments;
                /* A RUNNING engine is proof of health — never let a stale probe
                   verdict block an already-initialized FFmpeg. Without this a
                   false-broken verdict cached at page load could refuse init()
                   even after a warmup successfully loaded the core in the same
                   session (the old recovery was accidental — a re-upload). */
                if(typeof FFmpegProcessor.isReady==='function'&&FFmpegProcessor.isReady()){
                    return origInit.apply(FFmpegProcessor,args);
                }
                var probe=typeof window.__wasmHealthy==='function'?window.__wasmHealthy():Promise.resolve(true);
                return probe.then(function(healthy){
                    if(!healthy){
                        window.__wasmBrokenBanner&&window.__wasmBrokenBanner();
                        try{window.__ae&&window.__ae('feature_use',{slug:'wasm',f:'init_skipped_broken',tool:(window.__TOOL_SLUG||'unknown')})}catch(_){}
                        return false;
                    }
                    return origInit.apply(FFmpegProcessor,args);
                });
            };
        },100);
    })();
    /* Cascade fail-fast: when `wasm_init_attempt` reports the FIRST
       `outcome:timeout` (engine hung in WebAssembly.instantiate), classify
       as engine-broken and show the banner immediately. Network failures
       (`outcome:fail` with err matching /Failed to fetch|Load failed/) are
       transient — the cascade should keep trying alternative CDNs. Engine
       failures repeat byte-for-byte across CDNs and never recover, so
       waiting another 5 sources × 60 s is pure user-time waste.
       We patch __ae once before any caller; the FFmpegProcessor cascade
       keeps running in the background (no public abort hook on the loop)
       but the user already sees actionable advice ("open in Chrome"). */
    (function installCascadeWatcher(){
        // Poll for window.__ae — it's defined further down in this same
        // layout file, so synchronous install would race. Match the
        // installInitGate pattern above.
        var attempts=0;
        var iv=setInterval(function(){
            attempts++;
            if(typeof window.__ae!=='function'){
                if(attempts>50)clearInterval(iv); // 5 s max
                return;
            }
            clearInterval(iv);
            if(window.__cascadeWatched)return;
            window.__cascadeWatched=true;
            /* ⚠️ Until 2026-09-17 the watcher was a wrapper around window.__ae —
               and telemetry-tier0.js (deferred) RETIRES __ae at parse time
               («retire it unconditionally so no caller can reach the shim»),
               then installs the real emitter on consent. Whether the wrapper
               survived depended on whether this 100-ms poll fired before or
               after that deferred script ran: a race, lost on every slow
               machine. Field (RU, 30 d): 424 wasm_init_failed, ZERO
               wasm_engine_broken / wasm_engine_slow — the fail-fast this block
               exists for never once fired. The report of 16.09 sat 73 minutes
               in a cascade this watcher was designed to cut at ~90 s.
               Now ffmpeg-processor dispatches every attempt as a DOM event
               (`wasm-init-attempt`, alongside the telemetry row), and this
               listener is installed synchronously — no emitter, no race. */
            var enginedBroken=false;
            /* Accept-fail blind spot: pre-2026-06-02 the watchdog only fired
               on outcome:'timeout' (single 60-90 s per-attempt timeout). On a
               client where every source DETERMINISTICALLY rejects fast
               (AdGuard-style WASM-fetch block, YaBrowser cross-origin
               policy, captive portal), every attempt returns outcome:'fail'
               immediately and the cascade burns through all 5 sources × 2
               attempts in fractions of a second — but the user sits there
               for the FULL 7+ min wall-clock because no SINGLE attempt
               timed out. Prod telemetry 2026-06-02 showed events with
               ms=440804 (7m20s) of unbroken cascade because of this gap.
               Fast-abort on 2 consecutive cross-source network-class
               failures: at that point the next 8 attempts will give the
               exact same outcome. */
            var consecutiveFails=0, lastFailSrc='';
            var consecutiveTimeouts=0, lastTimeoutSrc='';
            /* Network-fail abort threshold is CONNECTION-AWARE. The old flat "abort
               after 2 distinct network-fails" was tuned for the AdGuard/captive-portal
               case (every source rejects in ms, deterministically). But on a flaky/slow
               mobile connection the same 2 quick "Failed to fetch" look identical to a
               pure counter, so it killed the off-origin CDNs (cdn.jsdelivr.net / unpkg.com)
               — exactly the sources likely to succeed when the same-origin RU edge is the
               thing failing (~290 wasm_init_failed/7d, cohort ct:4g/devMem4). On a slow/
               low-mem device a fetch failure is overwhelmingly recoverable, so let ALL
               distinct sources try; on fast/desktop keep the snappy 2-abort for the real
               deterministic block.
               2026-06-10: TIMEOUT branch ALSO connection-aware now. Old comment said
               an engine hang "repeats byte-for-byte across CDNs" — that's only true
               for deterministic instantiate hangs (AV intercepting WASM). For SLOW
               NETWORKS (dm<=4 / 3G / save-data) a 60-sec `Promise.race` rejection is
               overwhelmingly "this CDN proxy is slow today", NOT "WebAssembly is
               broken". Bug 2026-06-09 (valeriitaglin / Edge 149 / dm=4) — first
               visit hit one timeout → banner fired → user complained "switch to
               another browser". Second visit (same IP, same browser) ffmpeg-init
               succeeded in 11.7 sec. He wasn't broken; the gate was too tight.
               Now require 2 DISTINCT-source timeouts on slow-net (matches the
               fail-branch threshold). Fast-net users still get instant abort. */
            var _conn=navigator.connection||navigator.mozConnection||{};
            var _slowNet=/^(slow-2g|2g|3g)$/i.test(_conn.effectiveType||'')
                         || (typeof _conn.downlink==='number' && _conn.downlink>0 && _conn.downlink<3)
                         || !!_conn.saveData
                         || (typeof navigator.deviceMemory==='number' && navigator.deviceMemory<=4);
            var _failThreshold=_slowNet?5:2;
            var _timeoutThreshold=_slowNet?2:1;
            var isNetworkClassFail=function(err){
                return /Failed to fetch|Load failed|NetworkError|Network request failed|aborted/i.test(String(err||''));
            };
            function onAttempt(payload){
                if(!enginedBroken && payload){
                    if(payload.outcome==='timeout' || (payload.outcome==='fail' && isNetworkClassFail(payload.err))){
                        if(payload.outcome==='fail'){
                            /* Only count it if it's a DIFFERENT source than the previous
                               consecutive fail — otherwise a single source's two attempts
                               are not "the network is hosed", they're "this CDN is down". */
                            if(payload.src && payload.src !== lastFailSrc){
                                consecutiveFails++;
                                lastFailSrc=payload.src;
                            }
                        } else if(payload.outcome==='timeout'){
                            /* Same DISTINCT-source counting for timeouts so two sources
                               must independently time out before we mark the engine
                               broken on slow-net. */
                            if(payload.src && payload.src !== lastTimeoutSrc){
                                consecutiveTimeouts++;
                                lastTimeoutSrc=payload.src;
                            }
                        }
                        var _failTrip=consecutiveFails>=_failThreshold;
                        var _timeoutTrip=payload.outcome==='timeout' && consecutiveTimeouts>=_timeoutThreshold;
                        if(_failTrip || _timeoutTrip){
                            enginedBroken=true;
                            window.__lastFailedSrc=(payload.src||lastFailSrc)+'#'+payload.attempt+'@'+payload.ms+'ms'+(payload.outcome==='fail'?'|cross-source-fail':'');
                            /* Hard abort either way: ffmpeg-processor.js's _doInit loop
                               checks `window.__wasmInitAborted` between each source/attempt.
                               Stops the cascade after the current in-flight attempt rejects —
                               saves ~10 min × ~32 MB of pointless retries. The Try-anyway
                               button (which now calls __wasmHealthReset) clears the flag. */
                            window.__wasmInitAborted=true;
                            try{window.FFmpegProcessor&&FFmpegProcessor.abort&&FFmpegProcessor.abort()}catch(_){}
                            window.__wasmBrokenBanner&&window.__wasmBrokenBanner();
                            if(_failTrip){
                                /* Cross-source network-class failures: cut the ladder short
                                   and say so. NOT a sticky brick any more (2026-09-17): the
                                   fail class is «Failed to fetch» / «Load failed» — a link
                                   that dropped, which engine-load-retry.mjs measured to heal
                                   by itself within the delayed retry (56 recovered sessions
                                   in 30 d). Writing __wasm_health=0 here would refuse every
                                   later init() in the session, including that retry. The
                                   genuinely broken engines (SIMD, CSP-blocked WebAssembly)
                                   never reach this counter: their pre-flight fails before
                                   the first attempt. */
                                try{window.__ae&&window.__ae('wasm_engine_broken',{src:payload.src,attempt:payload.attempt,ms:payload.ms,via:payload.outcome})}catch(_){}
                                try{window.__aeCritical&&window.__aeCritical('wasm_engine_broken',{src:payload.src,attempt:payload.attempt,ms:payload.ms,via:payload.outcome})}catch(_){}
                            }else{
                                /* Network-class timeouts: the 32 MB core just didn't arrive
                                   over a slow link — NOT an engine defect. Do NOT persist
                                   sessionStorage='0' (that survives reloads and re-bricks the
                                   user on every visit, the valeriitaglin 2026-06-09 class).
                                   Abort the current grind + offer retry; the next attempt
                                   succeeds once bytes cache. Distinct telemetry so /pino can
                                   tell slow-network from broken-engine. */
                                try{window.__ae&&window.__ae('wasm_engine_slow',{src:payload.src,attempt:payload.attempt,ms:payload.ms})}catch(_){}
                            }
                        }
                    }else if(payload.outcome==='ok'){
                        /* A successful attempt resets the counter — transient flake on
                           one source then recovery via another should not poison the
                           gate. */
                        consecutiveFails=0; lastFailSrc='';
                        consecutiveTimeouts=0; lastTimeoutSrc='';
                    }
                }
            }
            window.addEventListener('wasm-init-attempt',function(ev){try{onAttempt(ev&&ev.detail)}catch(_){}});
        },50);
    })();
    // CDN router: RU users get VPS-first (blocked origins), everyone else gets CDN-first (edge speed).
    // Both modes have automatic fallback via .script() and .fetch() helpers.
    window.__CDN=(function(){
        var isRu=window.__IS_RU;
        var map={
            hf:{vps:'/cdn/hf',origin:'https://huggingface.co'},
            imgly:{vps:'/cdn/imgly',origin:'https://staticimgly.com'},
            gstorage:{vps:'/cdn/gstorage',origin:'https://storage.googleapis.com'},
            jsdelivr:{vps:'/cdn/jsdelivr',origin:'https://cdn.jsdelivr.net'},
            cdnjs:{vps:'/cdn/cdnjs',origin:'https://cdnjs.cloudflare.com'},
            gfonts:{vps:'/cdn/gfonts',origin:'https://fonts.googleapis.com'},
            gstatic:{vps:'/cdn/gstatic',origin:'https://fonts.gstatic.com'},
            ofm:{vps:'/cdn/ofm',origin:'https://tiles.openfreemap.org'}
        };
        function join(base,path){return base+(path.charAt(0)==='/'?path:'/'+path);}
        // The /cdn/ proxy lives ONLY on the Beget (RU) origin. RU pages ARE served
        // from Beget, so their VPS path is same-origin relative ('/cdn/*'). Non-RU
        // pages are served from the NL origin, which has NO /cdn/ proxy — a relative
        // '/cdn/*' fallback there 404s. So the non-RU VPS mirror must be the ABSOLUTE
        // Beget URL; Beget's /cdn/* sends Access-Control-Allow-Origin:* so both
        // <script src> and fetch() work cross-origin, and it keeps the fallback off
        // NL egress. Guard against a RU page that somehow isn't on timbrica.com.
        var RU_CDN=(isRu?'':'https://timbrica.com');
        function url(name,path){var m=map[name];if(!m)return path;return join(isRu?m.vps:m.origin,path);}
        function altUrl(name,path){var m=map[name];if(!m)return path;return join(isRu?m.origin:RU_CDN+m.vps,path);}
        function script(name,path,opts){
            opts=opts||{};
            return new Promise(function(resolve,reject){
                function tryLoad(src,onFail){
                    var s=document.createElement('script');
                    s.src=src;
                    if(opts.type)s.type=opts.type;
                    if(opts.crossOrigin)s.crossOrigin=opts.crossOrigin;
                    if(opts.async!==false)s.async=true;
                    s.onload=function(){resolve(s);};
                    s.onerror=onFail;
                    document.head.appendChild(s);
                }
                tryLoad(url(name,path),function(){tryLoad(altUrl(name,path),reject);});
            });
        }
        function fetchFallback(name,path,opts){
            var primary=url(name,path),fallback=altUrl(name,path);
            return globalThis.fetch(primary,opts).then(function(r){
                if(!r.ok&&r.status>=500)throw new Error('primary '+r.status);
                return r;
            }).catch(function(){return globalThis.fetch(fallback,opts);});
        }
        return {url:url,altUrl:altUrl,script:script,fetch:fetchFallback,isRu:isRu,map:map};
    })();

